/* ReactionView.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ReactionView.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useMemo } from 'react';
import { N500 } from '@atlaskit/theme/colors';
import Avatar from '@atlaskit/avatar/Avatar';
import Spinner from '@atlaskit/spinner';
import { TabPanel } from '@atlaskit/tabs';
import { Box, Flex } from '@atlaskit/primitives/compiled';
var userListStyle = null;
var userStyle = null;
var styles = {
  userDescriptionStyle: "_18u0utpp",
  profileWrapperStyle: "_18u0ze3t",
  reactionViewStyle: "_19pkutpp _1tke1mjv _1ul91deq",
  centerSpinnerStyle: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq _19pk1ejb"
};
export var ReactionView = function ReactionView(_ref) {
  var reaction = _ref.reaction,
    ProfileCardWrapper = _ref.ProfileCardWrapper;
  var alphabeticalNames = useMemo(function () {
    var _reactionObj$users;
    var reactionObj = reaction;
    return ((_reactionObj$users = reactionObj.users) === null || _reactionObj$users === void 0 ? void 0 : _reactionObj$users.sort(function (a, b) {
      return a.displayName.localeCompare(b.displayName);
    })) || [];
  }, [reaction]);
  return /*#__PURE__*/React.createElement(TabPanel, null, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    xcss: styles.reactionViewStyle
  }, alphabeticalNames.length === 0 ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.centerSpinnerStyle
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "large",
    interactionName: "reactions-spinner"
  })) : /*#__PURE__*/React.createElement("ul", {
    className: ax(["_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkpxbi _y3gn1e5h _nccu2smr _thoc15n8"]),
    style: {
      "--_1zdack": ix("".concat("var(--ds-text, ".concat(N500, ")")))
    }
  }, alphabeticalNames.map(function (user) {
    var _user$profilePicture;
    var profile = (_user$profilePicture = user.profilePicture) === null || _user$profilePicture === void 0 ? void 0 : _user$profilePicture.path;
    return /*#__PURE__*/React.createElement("li", {
      key: user.id,
      className: ax(["_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvidpf _u5f3idpf _24rcpxbi"])
    }, ProfileCardWrapper && user.accountId ? /*#__PURE__*/React.createElement(Box, {
      xcss: styles.profileWrapperStyle
    }, /*#__PURE__*/React.createElement(ProfileCardWrapper, {
      userId: user.accountId,
      isAnonymous: false,
      canViewProfile: true,
      position: "left-start"
    }, /*#__PURE__*/React.createElement(Avatar, {
      size: "medium",
      src: profile,
      testId: "profile"
    }))) : /*#__PURE__*/React.createElement(Avatar, {
      size: "medium",
      src: profile,
      testId: "profile"
    }), /*#__PURE__*/React.createElement(Flex, {
      xcss: styles.userDescriptionStyle
    }, /*#__PURE__*/React.createElement("div", null, user.displayName)));
  }))));
};